import { useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import PlayerSection from "./zakulisi/PlayerSection";
import UserSection from "./zakulisi/UserSection";
import TournamentSection from "./zakulisi/TournamentSection";
import MatchSection from "./zakulisi/MatchSection";

/**
 * Backstage / "Zákulisí" — SUPERADMIN-only bulk-edit tools.
 *
 * Sub-tabs each follow the same pattern: search input → results table → inline edit.
 * Mutations route through `/superadmin/**` endpoints; audit log captures every change.
 */
function ZakulisiTab() {
  const { t } = useTranslation();
  const [activeSubTab, setActiveSubTab] = useState<string>("players");

  return (
    <div className="mt-3">
      <Tabs
        activeKey={activeSubTab}
        onSelect={(k) => k && setActiveSubTab(k)}
        id="zakulisi-subtabs"
        variant="pills"
        className="mb-3"
      >
        <Tab eventKey="players" title={t("zakulisi__players")}>
          {activeSubTab === "players" && <PlayerSection />}
        </Tab>
        <Tab eventKey="users" title={t("zakulisi__users")}>
          {activeSubTab === "users" && <UserSection />}
        </Tab>
        <Tab eventKey="tournaments" title={t("zakulisi__tournaments")}>
          {activeSubTab === "tournaments" && <TournamentSection />}
        </Tab>
        <Tab eventKey="matches" title={t("zakulisi__matches")}>
          {activeSubTab === "matches" && <MatchSection />}
        </Tab>
      </Tabs>
    </div>
  );
}

export default ZakulisiTab;
